import React from 'react'
import {Icon} from '@chakra-ui/react'

const PodsIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            {/* <g clipPath="url(#clip0_1082_1384)">
                <path
                    d="M17.3144 12.2357L17.3144 12.2357L17.9151 22.071L17.3077 22.8654C17.3082 22.8657 17.3086 22.8661 17.3091 22.8664C17.6272 23.1092 18.0092 23.2393 18.4039 23.2393C18.6759 23.2393 18.9487 23.1777 19.2023 23.0532C19.8869 22.7179 20.2822 22.0121 20.2822 21.2876V13.8175C20.2822 13.089 19.8923 12.3916 19.2039 12.0544C18.582 11.7484 17.8625 11.8224 17.3144 12.2357Z"
                    stroke="currentColor"
                    strokeWidth="2"
                />
                <path
                    d="M23.0068 12.2357L23.0068 12.2357L22.4061 22.071L23.0136 22.8654C23.0131 22.8657 23.0127 22.8661 23.0122 22.8664C22.6941 23.1092 22.3121 23.2393 21.9174 23.2393C21.6454 23.2393 21.3726 23.1777 21.119 23.0532C20.4343 22.7179 20.039 22.0121 20.039 21.2876V13.8175C20.039 13.089 20.429 12.3916 21.1174 12.0544C21.7393 11.7484 22.4588 11.8224 23.0068 12.2357Z"
                    stroke="currentColor"
                    strokeWidth="2"
                />
                <path
                    d="M4 30.4311H36"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M33.9121 30.4311V28.1644C33.9121 27.4266 33.3165 26.831 32.5787 26.831H7.42318C6.6854 26.831 6.08984 27.4266 6.08984 28.1644V30.4311"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M31.1388 26.8314L29.9477 13.0356C29.6544 9.62225 26.7922 6.99999 23.37 6.99999H16.6322C13.2011 6.99999 10.3477 9.62225 10.0544 13.0356L8.86328 26.8314"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1082_1384">
                    <rect width="40" height="40" transform="translate(0 0.000244141)" />
                </clipPath>
            </defs> */}
            <path
                d="M38.0355 34.3457H1.96447C1.43401 34.3457 1 33.9117 1 33.3812C1 32.8508 1.43401 32.4167 1.96447 32.4167H38.0355C38.566 32.4167 39 32.8508 39 33.3812C39 33.9117 38.566 34.3457 38.0355 34.3457Z"
                fill="currentColor"
            />
            <path
                d="M35.6824 34.3457C35.152 34.3457 34.718 33.9117 34.718 33.3812V30.8254C34.718 30.5264 34.4769 30.2853 34.1779 30.2853H5.82255C5.52357 30.2853 5.28245 30.5264 5.28245 30.8254V33.3812C5.28245 33.9117 4.84844 34.3457 4.31798 34.3457C3.78753 34.3457 3.35352 33.9117 3.35352 33.3812V30.8254C3.35352 29.4655 4.46265 28.3563 5.82255 28.3563H34.1779C35.5378 28.3563 36.6469 29.4655 36.6469 30.8254V33.3812C36.6469 33.9117 36.2129 34.3457 35.6824 34.3457Z"
                fill="currentColor"
            />
            <path
                d="M32.5569 30.2853C32.065 30.2853 31.6407 29.9091 31.5925 29.4076L30.2518 13.8508C29.9625 10.533 27.127 7.92893 23.7996 7.92893H16.1996C12.8143 7.92893 10.0366 10.4751 9.74728 13.8508L8.40667 29.4076C8.35845 29.9381 7.90515 30.3335 7.36505 30.2853C6.83459 30.2371 6.43916 29.7741 6.48738 29.2437L7.82799 13.6868C8.20413 9.30812 11.8112 6 16.2092 6H23.8092C28.1397 6 31.8143 9.37563 32.1808 13.6868L33.5214 29.2437C33.5696 29.7741 33.1742 30.2371 32.6437 30.2853C32.6148 30.2853 32.5859 30.2853 32.5569 30.2853Z"
                fill="currentColor"
            />
            <path
                d="M17.3959 26.0417C16.8751 26.0417 16.3736 25.8391 15.9782 25.4533C14.4061 23.9295 12.5254 21.528 12.5254 18.7406C12.5254 15.9533 14.4929 13.4264 16.1421 11.864C16.7208 11.3239 17.5213 11.1792 18.235 11.4782C19.0066 11.8061 19.5081 12.5873 19.5178 13.4747L19.5564 18.731L19.5178 23.8041C19.5178 24.73 18.9873 25.5498 18.1772 25.8873C17.9264 25.9934 17.6564 26.0417 17.4056 26.0417H17.3959ZM17.4731 13.2335V13.2625C16.1036 14.5645 14.464 16.561 14.464 18.731C14.464 20.9011 16.0264 22.7914 17.3284 24.0645C17.3863 24.1224 17.4152 24.1127 17.4345 24.1031C17.502 24.0741 17.5888 23.9777 17.5888 23.7848L17.6274 18.7214L17.5888 13.4747C17.5888 13.3011 17.4924 13.2432 17.4731 13.2335Z"
                fill="currentColor"
            />
            <path
                d="M23.0666 26.0416C22.8159 26.0416 22.5555 25.9934 22.3047 25.8873C21.5331 25.5594 21.0316 24.7782 21.022 23.8909L20.9834 18.6345L21.022 13.5614C21.022 12.6355 21.5524 11.8157 22.3626 11.4782C23.1149 11.1599 23.954 11.3239 24.5616 11.9122C26.1337 13.436 28.0144 15.8472 28.0144 18.6249C28.0144 21.4025 26.0469 23.9391 24.3976 25.5015C24.0215 25.8584 23.5489 26.0416 23.0666 26.0416ZM23.1438 13.2431C23.1438 13.2431 23.1245 13.2431 23.1149 13.2431C23.0474 13.2721 22.9606 13.3685 22.9606 13.5614L22.922 18.6249L22.9606 23.8716C22.9606 24.0452 23.057 24.103 23.0763 24.1127L23.7418 24.7975L23.0763 24.0934C24.4458 22.7914 26.0854 20.7949 26.0854 18.6249C26.0854 16.4548 24.523 14.5645 23.221 13.2914C23.1824 13.2528 23.1631 13.2431 23.1438 13.2431Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default PodsIcon
